export const inactiveSubscriptionAlert = () => {
    alert("Membership inactive. Please contact business administrator.");
};

export const subscriptionRequiredAlert = () => {
    alert("Available with Platform Access. Please contact business administrator.");
};

export const insufficientCreditsAlert = () => {
    alert("Insufficient credits. Please contact business administrator.");
};
